import type Scroll from 'quill-next/blots/scroll';
import { ListeningArticleContainerBlock, Status } from './blots/listening-article-container';

// 获取所有container blot
export const findAllContainer = (scroll: Scroll) => {
  return scroll.descendants((blot: any) => {
    return blot.statics.blotName === 'listening-article-container';
  });
};

// 获取所有英文blot
export const findAllEn = (scroll: Scroll) => {
  return scroll.descendants((blot: any) => {
    return blot.statics.blotName === 'listening-article-en';
  });
};

// 获取所有中文blot
export const findAllCn = (scroll: Scroll) => {
  return scroll.descendants((blot: any) => {
    return blot.statics.blotName === 'listening-article-cn';
  });
};

// 判断当前状态
export const getStatus = (currentTime: number, blot: ListeningArticleContainerBlock, foundFirstPlaying: boolean): Status => {
  if (currentTime < blot.timeStart) {
    return 'toplay';
  }
  if (currentTime >= blot.timeStart && currentTime < blot.timeEnd) {
    if (!foundFirstPlaying) {
      return 'playing';
    } else {
      return 'toplay';
    }
  }
  return 'played';
};


